import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildForkTooltipTokens, } from "../utils/widgetHelpers";
import { ChartStatusLine } from "./canvas/ChartStatusLine";
import styles from "../styles/fork-overlays.module.css";
function changePercent(close, open) {
    if (open === 0)
        return "—";
    return `${((close - open) / open * 100).toFixed(2)}%`;
}
function changeColor(pct, color) {
    if (pct.startsWith("-"))
        return "#ef5350";
    if (pct === "0.00%" || pct === "—")
        return color;
    return "#26a69a";
}
export function ForkPaneTooltips({ hoveredDatum, lastDatum, symbol = "VIC", timeframe = "1D", isDark, paneSnapshots, panes, onSettingsClick, onToggleSeriesVisibility, onRemoveIndicator, onEditSeries, renderCompareLegend, hideStatusOhlc = false, showStatusVolume = true, }) {
    const snapshotMap = new Map(paneSnapshots.map((snapshot) => [snapshot.paneId, snapshot]));
    return panes.map((pane) => {
        if (pane.id === "volume" || pane.tooltip === "none") {
            return null;
        }
        const snapshot = snapshotMap.get(pane.id);
        if (!snapshot) {
            return null;
        }
        const leftAxisWidth = snapshot.axisBounds?.left?.width ?? 48;
        // The primary price pane gets the full GoCharting / TradingView status line
        if (pane.id === "price" || pane.tooltip === "ohlc") {
            return (_jsx(ChartStatusLine, { symbol: symbol, timeframe: timeframe, hoveredDatum: hoveredDatum, lastDatum: lastDatum, isDark: isDark, plotBounds: snapshot.plotBounds, leftAxisWidth: leftAxisWidth, onSettingsClick: onSettingsClick, onToggleSeriesVisibility: onToggleSeriesVisibility, onRemoveIndicator: onRemoveIndicator, onEditSeries: onEditSeries, pane: pane, compareLegend: renderCompareLegend?.(pane.id), hideMainRow: hideStatusOhlc, showVolume: showStatusVolume }, `fork-status-line-${pane.id}`));
        }
        // Secondary indicator panes (e.g. RSI, MACD) require hoveredDatum
        if (!hoveredDatum) {
            return null;
        }
        const textColor = isDark ? "#f8fafc" : "#1e2a3b";
        const labelColor = isDark ? "#d1d4dc" : "#64748b";
        const tokens = buildForkTooltipTokens(pane, hoveredDatum, textColor);
        const width = snapshot.plotBounds.width;
        let fontSize = "9.5px";
        let lineHeight = "13px";
        let gap = "2px 6px";
        if (width < 250) {
            fontSize = "7.5px";
            lineHeight = "10px";
            gap = "1px 3px";
        }
        else if (width < 400) {
            fontSize = "8.5px";
            lineHeight = "12px";
            gap = "1px 4px";
        }
        return (_jsx("div", { "data-rsc-fork-tooltip-pane": pane.id, className: `${styles.forkPaneTooltip} ${isDark ? styles.forkPaneTooltipDark : styles.forkPaneTooltipLight}`, style: {
                top: snapshot.plotBounds.top + 28,
                left: `calc(${leftAxisWidth}px - 3mm)`,
                maxWidth: Math.max(120, width - 16),
                fontSize,
                lineHeight,
                gap,
                fontWeight: "300",
                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
            }, children: tokens.map((token) => {
                const isOhlcLabel = token.key.endsWith("-open") || token.key.endsWith("-high") || token.key.endsWith("-low") || token.key.endsWith("-close") || token.key.endsWith("-volume");
                const currentLabelColor = isOhlcLabel ? labelColor : token.color;
                return (_jsxs("span", { children: [_jsx("span", { style: { color: currentLabelColor }, children: ` ${token.label} ` }), _jsx("span", { style: { color: token.color }, children: token.value }), token.key.endsWith("-close") && (_jsx("span", { style: { marginLeft: "4px", color: changeColor(changePercent(hoveredDatum.close, hoveredDatum.open), textColor) }, children: changePercent(hoveredDatum.close, hoveredDatum.open) }))] }, token.key));
            }) }, `fork-tooltip-${pane.id}`));
    });
}
